import React, { useState, useEffect } from "react";
import { TfiTimer } from "react-icons/tfi";
import styles from "./index.module.css";

// Utility function to format time as HH:MM:SS
const formatTime = (ms) => {
  let totalSeconds = Math.max(0, Math.floor(ms / 1000)); // prevent negative
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
    2,
    "0"
  );
  const seconds = String(totalSeconds % 60).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
};

const Timer = ({ expireTime }) => {
  const [remaining, setRemaining] = useState(() =>
    expireTime ? expireTime - Date.now() : 0
  );

  useEffect(() => {
    if (!expireTime) return;

    const interval = setInterval(() => {
      setRemaining(expireTime - Date.now());
    }, 1000);

    return () => clearInterval(interval); // cleanup on unmount
  }, [expireTime]);

  return (
    <div className={styles.proposedAssetsTimer}>
      <TfiTimer size={25} />
      <h4 className={styles.proposedAssetsHeaderTime}>
        {formatTime(remaining)}
      </h4>
    </div>
  );
};

export default Timer;
